import { LogisticStatus, LogisticStatuses, ProductStatus, ProductStatuses } from 'api/cars'
import { getProjectName } from 'lib/get-project-name'

import { CarData } from '../types'

const lowerFirst = (string: string) => string[0].toLowerCase() + string.slice(1)

const STATUS_TO_COLOR: Record<LogisticStatuses | ProductStatuses, string> = {
  on_the_way: '#ffe000',
  in_the_central_warehouse: '#29730f',
  in_production: '#8e8e8e',
  in_stock: '#3db014',
  active: '#3db014',
  sold: '#ff0000',
  reserved: '#c5172d',
  not_active: '#888'
}

const STATUS_TO_COLOR_GENERIC_V2: Record<LogisticStatuses | ProductStatuses, string> = {
  on_the_way: '#D97B46',
  in_the_central_warehouse: '#29730f',
  in_production: '#8e8e8e',
  in_stock: '#46D96F',
  active: '#46D96F',
  sold: '#ff0000',
  reserved: '#c5172d',
  not_active: '#888'
}

const STATUS_TO_COLOR_CCTRUCK: Record<LogisticStatuses | ProductStatuses, string> = {
  on_the_way: '#ffe000',
  in_the_central_warehouse: '#29730f',
  in_production: '#8e8e8e',
  in_stock: '#1DC624',
  active: '#3db014',
  sold: '#ff0000',
  reserved: '#c5172d',
  not_active: '#888'
}

export const createCarStatus = ({
  status,
  logisticStatus,
  quantity
}: {
  status?: ProductStatus
  logisticStatus: LogisticStatus
  quantity?: number
}): CarData['status'] => {
  const visibleStatus = !status || status.id === 'active' ? logisticStatus : status

  return {
    text:
      quantity && quantity > 1 && (visibleStatus.id === 'active' || visibleStatus.id === 'in_stock')
        ? `${quantity} ${lowerFirst(visibleStatus.name)}`
        : visibleStatus.name,
    color:
      getProjectName() === 'generic_v2' || getProjectName() === 'volvo'
        ? STATUS_TO_COLOR_GENERIC_V2[visibleStatus.id]
        : getProjectName() === 'cctruck'
        ? STATUS_TO_COLOR_CCTRUCK[visibleStatus.id]
        : STATUS_TO_COLOR[visibleStatus.id]
  }
}
export const getCarAvailability = (status?: ProductStatus): boolean => {
  if (!status) return true //todo: убрать когда статус перестанет быть опциональным в baseCarModel
  return !['sold', 'not_active', 'reserved'].includes(status.id)
}
